export const callsKeys = {
  agents: (locationId: string) => ['calls', 'agents', locationId] as const,
  log: (locationId: string) => ['calls', 'log', locationId] as const,
  health: (locationId: string) => ['calls', 'health', locationId] as const,
  // Prefixed by log(locationId) so invalidating the log refreshes every filter.
  logFiltered: (
    locationId: string,
    filters: { agentId?: string; since?: string; openCallbacks?: boolean },
  ) => ['calls', 'log', locationId, filters] as const,
  stats: (locationId: string) => ['calls', 'stats', locationId] as const,
  numbers: (locationId: string) => ['calls', 'numbers', locationId] as const,
  availableNumbers: (locationId: string) => ['calls', 'numbers', 'available', locationId] as const,
  // Prefixed by availableNumbers(locationId) so invalidating that refreshes every variant.
  availableNumbersFor: (locationId: string, excludeAgentId?: string) =>
    ['calls', 'numbers', 'available', locationId, excludeAgentId ?? null] as const,
  sources: (locationId: string) => ['calls', 'sources', locationId] as const,
  attribution: (locationId: string) => ['calls', 'sources', 'attribution', locationId] as const,
  closures: (locationId: string) => ['calls', 'closures', locationId] as const,
  templateTopics: (templateKey: string) => ['calls', 'templates', templateKey, 'topics'] as const,
};
